
import { useState } from 'react';
import ConsultationPopup from '../../../components/feature/ConsultationPopup';

export default function HeroSection() {
  const [showConsultationPopup, setShowConsultationPopup] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/548bbbd77e6f7dd40c6ae72ab0ae2578.jpg')`
          }}
        />
        
        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
              We Help Brands Scale Through{' '}
              <span className="text-blue-600">E-commerce Marketing</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
              From performance marketing to full-funnel strategy — we handle everything that grows your online business.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => setShowConsultationPopup(true)}
                className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap"
              >
                Get Free Consultation
              </button>
              <a
                href="/services"
                className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors whitespace-nowrap"
              >
                Explore Services
              </a>
            </div>
          </div>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-blue-200 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-blue-300 rounded-full opacity-20 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-20 w-16 h-16 bg-blue-400 rounded-full opacity-20 animate-pulse delay-500"></div>
      </section>

      {/* Consultation Popup */}
      <ConsultationPopup 
        isOpen={showConsultationPopup}
        onClose={() => setShowConsultationPopup(false)}
      />
    </>
  );
}
